import {useState} from "react";
import { ulid } from "ulid";
import API from "../Services/API";
import Model from "./Model";
import { useToasts } from "../Components/Toasts";

const useThread = (threadId, alwaysRefresh, includeOwnerNotificationLogs) => {
    const include = includeOwnerNotificationLogs ? 'include=ownerNotificationLogs' : '';
    return Model({
        alwaysRefresh,
        stateKey: ['thread', threadId, include],
        fetchData: () => API.get(`/messages/thread/${threadId}?${include}`),
        returnDataKey: 'thread',
        registerAdditionalMethods: (opts) => {
            return {
                addReply: (content) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/messages/send', {
                            threadId,
                            content,
                            direction: 'Outbound',
                            id: ulid(),
                        }),
                        'Message sent',
                        true,
                    );
                },
            }
        },
        defaultLoadingError: 'Failed to conversation.',
    });
}

const useRefineMessage = (threadId) => {
    const [isRefining, setIsRefining] = useState(false);
    const {showError} = useToasts();

    const refine = (content, action) => {
        return new Promise((resolve, reject) => {
            setIsRefining(true);
            API.post('/messages/refine', {threadId, content, action}).then(res => {
                setIsRefining(false);
                // showSuccess('Message refined');
                resolve(res.content);
            }).catch(err => {
                setIsRefining(false);
                showError(API.parseErrorResponse(err));
                reject(err);
            });
        })
    }

    return {
        refine,
        isRefining,
    }
}


const useSuggestThreadReplies = (threadId) => {
    return Model({
        returnDataKey: 'replies',
        stateKey: ['threadReplies', threadId],
        alwaysRefresh: true,
        fetchData: async () => API.get(`/messages/thread/${threadId}/suggestedReplies`),
    });
}

const useMessageLibrary = (type) => {
    const _type = type.indexOf('/') ? type.split('/')[1].toLowerCase() : type.toLowerCase();

    return Model({
        returnDataKey: 'messages',
        stateKey: ['messageLibrary', type],
        alwaysRefresh: true,
        fetchData: async () => API.get(`/messages/libraries/${_type}`),
        registerAdditionalMethods: (opts) => {
            return {
                createMessage: (content) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/messages/libraries/${_type}/message`, {content}),
                        'Message saved',
                        true,
                    );
                },
                deleteMessage: (messageId) => {
                    return opts.wrapUpdateCall(
                        () => API.delete(`/messages/libraries/${_type}/message/${messageId}`),
                        'Message deleted',
                        true,
                    );
                },
                /*
                updateMessage: (message) => saveRefreshAction(
                    options,
                    'post',
                    `/messages/libraries/${type}/message/${message.id}`,
                    message,
                    'Message updated'
                ),
                deleteMessage: (message) => saveRefreshAction(
                    options,
                    'delete',
                    `/messages/libraries/${type}/message/${message.id}`,
                    message,
                    'Message deleted'
                ),
                */
            }
        }
    });
}


export {
    useThread,
    useRefineMessage,
    useSuggestThreadReplies,
    useMessageLibrary,
}
